import { render } from "./InstallationDetail.vue?vue&type=template&id=5e8b1feb&scoped=true&ts=true"
import script from "./InstallationDetail.vue?vue&type=script&lang=ts"
export * from "./InstallationDetail.vue?vue&type=script&lang=ts"

import "./InstallationDetail.vue?vue&type=style&index=0&id=5e8b1feb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8b1feb"]])

export default __exports__